import callApi, { CallApiResult, getCustomerId } from 'src/api';

export const fetchProducts = (productGroup: string, excludeSetProducts?: string, name?: string) => {
    const endpoint = '/api/products/admin';
    const customerId = getCustomerId();
    const header: Record<string, string> = { productGroup, customerId };

    if (name !== undefined) {
        header.name = name;
    }

    if (excludeSetProducts) {
        return callApi(endpoint, { headers: { ...header, excludeSetProducts } });
    }
    return callApi(endpoint, { headers: { ...header } });
};

export const fetchProductByIdentifier = (identifier: string): Promise<CallApiResult<any>> => {
    const endpoint = `/api/products/${identifier}`;
    const customerId = getCustomerId();
    return callApi(endpoint, { headers: { customerId } });
};
